export default function Footer() {
  return (
    <footer className="bg-[#ff6b35] text-black py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-3xl font-black mb-4">MASTER JAE</h3>
            <p className="text-black/80 mb-4">
              Your Vision, Professionally Crafted.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://web.facebook.com/profile.php?id=100054493058930" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full bg-black text-[#ff6b35] flex items-center justify-center hover:bg-gray-800 transition-colors duration-300 cursor-pointer"
                aria-label="Visit Master Jae Production on Facebook"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a 
                href="mailto:masterjaemultimedialap@gmail.com"
                className="w-10 h-10 rounded-full bg-black text-[#ff6b35] flex items-center justify-center hover:bg-gray-800 transition-colors duration-300 cursor-pointer"
                aria-label="Email Master Jae Production"
              >
                <i className="ri-mail-line"></i>
              </a>
              <a 
                href="tel:+27817844091"
                className="w-10 h-10 rounded-full bg-black text-[#ff6b35] flex items-center justify-center hover:bg-gray-800 transition-colors duration-300 cursor-pointer"
                aria-label="Call Master Jae Production"
              >
                <i className="ri-phone-line"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xl font-bold mb-4">
              <a href="#services" className="hover:underline">SERVICES</a>
            </h4>
            <ul className="space-y-2 text-black/80">
              <li><a href="#services" className="hover:text-black transition-colors duration-300 cursor-pointer">Music Studio</a></li>
              <li><a href="#services" className="hover:text-black transition-colors duration-300 cursor-pointer">Graphic Design</a></li>
              <li><a href="#services" className="hover:text-black transition-colors duration-300 cursor-pointer">Post Production</a></li>
              <li><a href="#services" className="hover:text-black transition-colors duration-300 cursor-pointer">Recording & Mixing</a></li>
              <li><a href="#services" className="hover:text-black transition-colors duration-300 cursor-pointer">Brand Identity</a></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-4">
              <a href="#about" className="hover:underline">QUICK LINKS</a>
            </h4>
            <ul className="space-y-2 text-black/80">
              <li><a href="#about" className="hover:text-black transition-colors duration-300 cursor-pointer">About Us</a></li>
              <li><a href="#portfolio" className="hover:text-black transition-colors duration-300 cursor-pointer">Portfolio</a></li>
              <li><a href="#pricing" className="hover:text-black transition-colors duration-300 cursor-pointer">Pricing</a></li>
              <li><a href="#testimonials" className="hover:text-black transition-colors duration-300 cursor-pointer">Testimonials</a></li>
              <li><a href="#contact" className="hover:text-black transition-colors duration-300 cursor-pointer">Contact</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xl font-bold mb-4">
              <a href="#contact" className="hover:underline">CONTACT</a>
            </h4>
            <ul className="space-y-3 text-black/80">
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>8422 Mandela Section<br />Tumahole, Parys, 9585</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-phone-line"></i>
                <a href="tel:+27817844091" className="hover:text-black transition-colors duration-300">081 784 4091</a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-mail-line"></i>
                <a href="mailto:masterjaemultimedialap@gmail.com" className="hover:text-black transition-colors duration-300 break-all">masterjaemultimedialap@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-black/20 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-black/80 text-sm">
            © 2025 Master Jae Production. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-black/80 text-sm hover:text-black transition-colors duration-300"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
